import InstanceFactory from '../factories/InstanceFactory';
class UIUtils {
    /**
     * Shows a message box and waits until the user press the ok/continue button.
     *
     * WARNING: Do not forget to use the await keyword!
     * ```ts
     * // code before the popup is shown.
     * await UIUtils.showMessageBox(message, title);
     * // code to execute after the popup has been closed.
     * ```
     * @param {string} message The message to display.
     * @param {string} title The messagebox's title text.
     * @return {*}  {Promise<void>} awaitable message box.
     * @memberof UIUtils
     */
    public async showMessageBox(message: string, title: string): Promise<void> {
        return new Promise<void>((resolve) => {
            let box = InstanceFactory.getClass("MessagePopup");
            box.show(() => {
                resolve();
            });

            box.title.text = title;
            box.text.text = message;
        });
    }

    /**
     * Shows an error message box and waits until the user press the ok/continue button.
     *
     * WARNING: Do not forget to use the await keyword!
     * ```ts
     * // code before the popup is shown.
     * await UIUtils.showErrorBox(errorMessage, title);
     * // code to execute after the popup has been closed.
     * ```
     * @param {string} errorMessage The error message to display.
     * @param {string} [title="Error"] The error messagebox popup title text.
     * @return {*}  {Promise<void>}
     * @memberof UIUtils
     */
    public async showErrorBox(errorMessage: string, title: string = "Error"): Promise<void> {
        return new Promise<void>((resolve) => {
            let box = InstanceFactory.getClass("ErrorPopup");
            box.show(() => {
                resolve();
            });

            box.title.text = title;
            box.text.text = errorMessage;
        });
    }
}

export default new UIUtils();
